<template>
  <div>
    <!-- 导航栏 -->
    <Navbar />

    <div class="main-content">
      <div style="width:92%;max-width:1200px;margin:0 auto;">
        <div class="register-wrapper">
          <h2 class="register-title">用户注册</h2>

          <van-form @submit="doRegister">
            <!-- 大卡片容器 -->
            <div class="register-card">
              <div class="field-row">
                <van-field
                  v-model="formData.username"
                  name="username"
                  label="用户名"
                  placeholder="请输入用户名（3-16位）"
                  maxlength="16"
                />
              </div>
              <div class="field-row">
                <van-field
                  v-model="formData.password"
                  name="password"
                  label="密码"
                  placeholder="请设置6-16位密码"
                  type="password"
                  maxlength="16"
                />
              </div>
              <div class="field-row">
                <van-field
                  v-model="formData.confirmPwd"
                  name="confirmPwd"
                  label="确认密码"
                  placeholder="请再次输入密码"
                  type="password"
                  maxlength="16"
                />
              </div>

              <!-- 验证码区域 -->
              <div class="captcha-row">
                <div class="captcha-input-box">
                  <van-field
                    v-model="captchaInput"
                    placeholder="请输入验证码（点击图片可刷新）"
                    maxlength="4"
                  />
                </div>
                <canvas
                  ref="captchaCanvas"
                  width="150"
                  height="50"
                  class="captcha-canvas"
                  @click="refreshCaptcha"
                  title="点击刷新验证码"
                ></canvas>
              </div>
              <div v-if="captchaErrorText" class="captcha-error">{{ captchaErrorText }}</div>
            </div>

            <!-- 错误信息 -->
            <div v-if="errorMsg" class="error-msg">{{ errorMsg }}</div>

            <!-- 提交按钮 -->
            <div class="submit-area">
              <van-button
                native-type="submit"
                type="primary"
                block
                round
                size="large"
                :loading="submitting"
              >立即注册</van-button>
            </div>

            <div class="form-tip">
              已有账号？<a @click="$router.push('/login')">去登录</a>
            </div>
          </van-form>
        </div>
      </div>
    </div>

    <!-- 页脚 -->
    <div class="footer">
      <p>鱿鱼云码 - 智能验证码识别平台 © 2026 版权所有</p>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import { Toast } from 'vant'

export default {
  name: 'Register',
  components: { Navbar },
  data() {
    return {
      formData: {
        username: '',
        password: '',
        confirmPwd: ''
      },
      captchaInput: '',
      errorMsg: '',
      captchaErrorText: '',
      submitting: false,
      _fallbackCode: ''
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.drawCaptcha()
    })
  },
  methods: {
    drawCaptcha() {
      const canvas = this.$refs.captchaCanvas
      if (!canvas) return
      const ctx = canvas.getContext('2d')
      const w = 150, h = 50
      const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789'
      let code = ''
      for (let i = 0; i < 4; i++) code += chars[Math.floor(Math.random() * chars.length)]
      this._fallbackCode = code

      const g = ctx.createLinearGradient(0, 0, w, h)
      g.addColorStop(0, '#e8eaf6')
      g.addColorStop(1, '#c5cae9')
      ctx.fillStyle = g
      ctx.fillRect(0, 0, w, h)

      for (let i = 0; i < 4; i++) {
        ctx.beginPath()
        ctx.moveTo(Math.random() * w, Math.random() * h)
        ctx.lineTo(Math.random() * w, Math.random() * h)
        ctx.strokeStyle = `rgba(${r()},${r()},${r()},0.5)`
        ctx.lineWidth = 1
        ctx.stroke()
      }
      for (let i = 0; i < 30; i++) {
        ctx.beginPath()
        ctx.arc(Math.random() * w, Math.random() * h, 1.2, 0, Math.PI * 2)
        ctx.fillStyle = `rgba(${r()},${r()},${r()},0.5)`
        ctx.fill()
      }
      const colors = ['#1a237e', '#b71c1c', '#1b5e20', '#e65100', '#4a148c', '#006064']
      for (let i = 0; i < code.length; i++) {
        ctx.save()
        ctx.translate(14 + i * 26, h / 2 + 6)
        ctx.rotate((Math.random() - 0.5) * 0.5)
        ctx.font = `bold ${20 + Math.floor(Math.random() * 6)}px Arial`
        ctx.fillStyle = colors[i % colors.length]
        ctx.fillText(code[i], 0, 0)
        ctx.restore()
      }

      function r() { return Math.floor(Math.random() * 150 + 50) }
    },

    refreshCaptcha() {
      this.captchaInput = ''
      this.captchaErrorText = ''
      this.drawCaptcha()
    },

    validate() {
      this.errorMsg = ''
      this.captchaErrorText = ''

      if (!this.formData.username) { this.errorMsg = '请输入用户名'; return false }
      if (this.formData.username.length < 3) { this.errorMsg = '用户名至少3位'; return false }
      if (!this.formData.password) { this.errorMsg = '请输入密码'; return false }
      if (this.formData.password.length < 6) { this.errorMsg = '密码至少6位'; return false }
      if (!this.formData.confirmPwd) { this.errorMsg = '请再次输入密码'; return false }
      if (this.formData.password !== this.formData.confirmPwd) { this.errorMsg = '两次密码输入不一致'; return false }
      if (!this.captchaInput) { this.captchaErrorText = '请输入验证码'; return false }
      if (this.captchaInput.toLowerCase() !== this._fallbackCode.toLowerCase()) {
        this.captchaErrorText = '验证码错误'
        this.refreshCaptcha()
        return false
      }
      return true
    },

    doRegister() {
      if (!this.validate()) return
      this.submitting = true
      setTimeout(() => {
        this.submitting = false
        Toast({
          message: '注册成功',
          duration: 1500,
          onClose: () => { this.$router.push('/login') }
        })
      }, 800)
    }
  }
}
</script>

<style scoped>
.main-content { flex: 1; padding-bottom: 40px; }
.register-wrapper {
  width: 100%;
  max-width: 480px;
  margin: 60px auto;
  padding: 40px 20px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 20px rgba(0,0,0,0.08);
}
.register-title {
  font-size: 26px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 28px;
}
.register-card {
  margin: 0 12px;
  background: #fff;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #ebedf0;
}
.field-row { display: block; }
.field-row + .field-row { border-top: 1px solid #ebedf0; }
.captcha-row {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 10px 16px;
  border-top: 1px solid #ebedf0;
}
.captcha-input-box { flex: 1; }
.captcha-canvas {
  flex-shrink: 0;
  cursor: pointer;
  border-radius: 6px;
  border: 1px solid #c5cae9;
  display: block;
}
.captcha-error { font-size: 12px; color: #ee0a24; padding: 0 16px 8px; }
.error-msg { font-size: 12px; color: #ee0a24; padding: 6px 16px 0; }
.submit-area { margin: 16px 12px 0; }
.form-tip {
  text-align: center;
  color: #666;
  font-size: 14px;
  margin-top: 16px;
  cursor: pointer;
}
.form-tip a {
  color: #002080;
  text-decoration: none;
  font-weight: 500;
  cursor: pointer;
}
</style>
